export enum EventType {
	GOT_AMMO,
	GOT_WEAPON,
	GOT_ITEM,
	PLAYER_DIED,
	REACHED_AREA,
	PLAYER_HEALED,
	DO_NOT_HAVE_KEY,
	CONTAINER_OPENS,
	LEVEL_DIRECTOR_HOSTILITY_REACHED_1,
	LEVEL_DIRECTOR_HOSTILITY_REACHED_2,
	LEVEL_DIRECTOR_HOSTILITY_REACHED_3,
	LEVEL_DIRECTOR_HOSTILITY_REACHED_4,
	LEVEL_DIRECTOR_HOSTILITY_REACHED_5,
	DEV_KILL_BOT_ACTIVATED,
	DEV_KILL_BOT_DEACTIVATED,
	TERMINAL_OPENED_BLAST_DOORS,
	EQUATION_IS_HERE,
	EQUATION_FOUND,
	PLAYER_FULLY_HEALED,
	CANT_HEAL_ALREADY_FULL_HEALTH,
	CANT_PUT_MINE_HERE,
	NO_PATH_FOR_AUTOMOVE,
	POWER_PLANT_ACTIVATED,
	POWER_PLANT_GATE_NO_POWER,
	POWER_PLANT_GATE_NO_KEYCARD,
	POWER_PLANT_GATE_OPENED,
	VENDING_MACHINE_NO_POWER,
	TERMINAL_NO_POWER,
	TERMINAL_NO_KEYCARD,
	FIRST_WEAPON_PICKUP,
	LOW_HP_MEDIKIT_HINT,
	HINT,
}
